export const environment = {
  production: false,
  groupName: "--",
  apiUrl: "https://aimode-api-dev.azure.chevron.com/api/v1",
  clientId: "b9c5e93d-5dda-49b5-bf6d-dcccbfb55088",
  tenantId: "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
};
